// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1myI8","footer":"Form_footer__2D6_r"};